module.exports = __webpack_public_path__ + "img/Speaker=Vivek Gupta.696ac6eb.png";